import PropTypes from 'prop-types';

const TagButton = ({ tagName, isSelected, onClick }) => {
  const buttonStyle = {
    margin: '5px',
    padding: '5px 10px',
    cursor: 'pointer',
    backgroundColor: isSelected ? 'lightblue' : 'white',
  };

  return (
    <button
      type="button"
      style={buttonStyle}
      onClick={() => onClick(tagName)}
    >
      {tagName}
    </button>
  );
};

TagButton.defaultProps = {
  isSelected: () => false,
};

TagButton.propTypes = {
  tagName: PropTypes.string.isRequired,
  isSelected: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default TagButton;
